import styled from "styled-components";
import { getMarginX } from "../utils";

interface StyledContainerProps {
  thumbSize: number;
}

export default styled.div<StyledContainerProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 ${({ thumbSize }) => getMarginX(thumbSize)}px;
  position: relative;
`;
